export const en = {
    "user": {
        "profile": "Profile",
        "logout": "Logout"
    },
    "sidebar": {
        "citCentre": "Situational centre",
        "citCentreHelloFirst": "Welcome to situational centre's administration panel!",
        "citCentreHelloSecond": "To start working, you can select one category from the left sidebar.",
        "administratingSystem": "Administration system",
        "masterDataManagementSubSystem": "Master data management sub-system",
        "dynamicFactorsInputSubSystem": "Dynamic factors input sub-system",
        "handbooksManagementSubSystem": "Handbooks management sub-system",
        "actualIndicators": "Actual indicators",
        "industries": "Industries",
        "plannedFactorsAccountingSubSystem": "Planned factors accounting subsystem",
        "publicDataManagementSubSystem": "Public data management system",
        "publication": "Publication"
    },
    "warnings": {
        "readOnlyHandbook": "This handbooks is not available for modifications. Only viewing is available.",
        "noIndustrySelectedForEditing": "There is no selected industry for editing!",
        "waitUntilIndustriesTreeIsLoaded": "Wait until industries tree is loaded.",
        "youReEditingIndustrySphere": "You are editing industry sphere",
        "youReEditingIndustryBranch": "You are editing industry branch",
        "youReCreatingIndustrySphere": "You are creating industry sphere",
        "youReCreatingIndustryBranch": "You are creating industry branch",
        "addedIndustryWillBeChildFor": "Added industry will be child for",
        "saved": "Saved",
        "industryElementHasBeenSaved": "Industry element has been updated!",
        "handbookItemHasBeenUpdated": "Handbook item has been updated!",
        "handbookItemHasBeenCreated": "New handbook item has been created!",
        "indicatorInformationIsSaved": "Indicator's data has been updated!",
        "indicatorHasBeenCreated": "Indicator has been created!",
        "factorHasBeenCreated": "New factor has been created!",
        "factorHasBeenUpdated": "Factor's data has been updated!"
    },
    "actions": {
        "selectOneIndustryToEditFromTheLeftList": "Select industry for editing from list on the left side.",
        "addNewHandbookItem": "Add new handbook item",
        "addNewChildIndustryBranch": "Add new child industry branch",
        "addNewIndustrySphere": "Add new industry sphere",
        "addNewIndicator": "Add new indicator",
        "creationOfANewIndicator": "Creation of a new indicator",
        "creationOfANIndicator": "Creating an indicator",
        "managingHandbooks": "Handbooks management",
        "editing": "Editing",
        "others": "Other",
        "import": "Import",
        "indicatorEditing": "Indicator editing",
        "industryInformationEditing": "Editing industry's information",
        "allAmount": "All amount",
        "selected": "Selected",
        "makeChanges": "Make changes",
        "saveChanges": "Save changes",
        "revertChanges": "Revert changes",
        "selectActivityType": "Select an activity type",
        "finishCreation": "Finish creation",
        "importFromExcel": "Import from Excel",
        "importFromCSV": "Import from CSV",
        "selectPeriodicity": "Select periodicity",
        "selectMeasureUnitShortened": "Select meas. un.",
        "selectInformationSourceShortened": "Select inf. src.",
        "selectSourceSystemShortened": "Select src. sys.",
        "addFactor": "Add factor",
        "getLink": "Obtain link",
        "viewRaw": "View raw",
        "copyThisIntoClipboard": "Copy this into clipboard"
    },
    "common": {
        "name": "Name",
        "names": "Names",
        "alternativeName": "Alternative name",
        "comment": "Comment",
        "type": "Type",
        "factors": "Factors",
        "handbooks": "Handbooks",
        "industrySphereOrBranch": "Sphere / Branch",
        "taldauIdentifier": "Taldau identifier",
        "activityType": "Activity type",
        "periodicity": "Periodicity",
        "inRussian": "in russian",
        "inEnglish": "in english",
        "inKazakh": "in kazakh",
        "inRussianLanguage": "in russian language",
        "inEnglishLanguage": "in english language",
        "inKazakhLanguage": "in kazakh language",
        "industrySphere": "Sphere",
        "industryBranch": "Branch",
        "minValue": "Minimal value",
        "maxValue": "Maximal value",
        "measureUnit": "Measure unit",
        "values": "Values",
        "value": "Value",
        "linkedDocuments": "Linked documents",
        "region": "Region",
        "district": "District",
        "districtOrRegion": "District/Region",
        "plan": "Plan",
        "period": "Period",
        "user": "User",
        "anyValue": "Any value",
        "available": "Available",
        "notAvailable": "Not available",
        "advancedSearchParameters": "Advanced search parameters",
        "yes": "Yes",
        "no": "No",
        "systemIdentifierContainment": "Containment of system identifier"
    },
    "loadings": {
        "loadingIndustriesTree": "Loading industries tree. Please wait ...",
        "loadingIndustryInformation": "Loading information about selected industry"
    },
    "indicators": {
        "listOfFactorsForSelectedIndicator": "List of factors for the selected indicator",
        "dynamicFactorsInputByPeriodicity": "Dynamic factors input by indicators' periodicity",
        "masterDataManagement": "Master data management",
        "informationAboutIndicator": "Information about this indicator",
        "editingInformationAboutThisIndicator": "Editing information about this indicator",
        "logicalRange": "Logical values range",
        "informationSource": "Information source",
        "sourceSystem": "Source system",
        "thisIndicatorIsBeing": "This indicator is ",
        "factorsOfThisIndicatorAreVerified": "Factors' data of this indicator is verified or checked",
        "factorsOfThisIndicatorAreNotVerified": "Factors' data of this indicator is not verified or checked",
        "beingPositive": "positive",
        "beingNegative": "negative",
        "beingDepricated": "obsolete",
        "beingPublic": "public",
        "factorsBeingRaisedIsAGoodSign": "Factors' values raising is a good sign",
        "factorsBeingRaisedIsABadSign": "Factors' values raising is a bad sign",
        "plannedValueIsAvailableForFactorsOfThisIndicator": "Planned value is available for factors of this indicator",
        "divisionByRegions": "Division by regions",
        "noDivisionByRegions": "No division by regions",
        "divisionByRegionsDescription": "If checked, factors of this indicator must be specified by region",
        "plannedValueAvailable": "Planned value is available",
        "noPlannedValueAvailable": "No planned value",
        "plannedValueAvailableDescription": "If checked, factors of this indicator can have planned value",
        "linkedDocumentsSelectionDescription": "Indicator can implement specific documents. Required documents can be selected from the list below.",
        "positive": "Positive",
        "negative": "Negative",
        "positiveDescription": "If checked, indicator will have positive side of effect.",
        "verified": "Verified",
        "notVerified": "Not verified",
        "verifiedDescription": "If checked, factors of this indicator will have priority of a verified source.",
        "obsolete": "Obsolete",
        "actual": "Actual",
        "obsoleteDescription": "If checked, indicator will be marked as obsolete.",
        "flags": "Flags",
        "factorsOfIndicator": "Factors of indicator",
        "plannedFactorsAccounting": "Planned factors accounting",
        "plannedValue": "Planned value",
        "dataVerificationStatus": "Data verification status",
        "dataFactorsPositivity": "Data positivity",
        "dataPublicity": "Data publicity",
        "public": "Public",
        "private": "Private",
        "publicDescription": "If checked, this indicator will be public. Data of it's factors can be viewed in systems with public access.",
        "publicOrOpenDataPublication": "Open/public data publication"
    },
    "industrySelectionOverlay": {
        "p1": "In this tree view",
        "p2": "Analytical",
        "p3": "industries' spheres and branches prefixed with a icon",
        "p4": " and",
        "p5": "Operational",
        "p6": " with icon",
        "p7": "Tree root elements are always",
        "p8": "Spheres",
        "p9": " and their child elements are ",
        "p10": "Branches"
    },
    "changeLang": {
        "changeLanguage": "Change language",
        "russian": "Russian",
        "english": "English",
        "kazakh": "Kazakh"
    }
};